import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule} from "@angular/router";
import {BhFooterModule} from "../../../components/bh-footer/bh-footer.module";
import {BhCrumbsModule} from "../../../components/bh-crumbs/bh-crumbs.module";
import {BhHeaderModule} from "../../../components/bh-header/bh-header.module";
import {TranslocoPipe} from "@ngneat/transloco";
import {AppPipesModule} from "../../../../app.pipes.module";
import {BhPageStoreComponent} from "./bh-page-store.component";
import {BhAwardsModule} from "../../../components/bh-awards/bh-awards.module";
import {BhGradesModule} from "../../../components/bh-grades/bh-grades.module";
import {BhGarantieModule} from "../../../components/bh-garantie/bh-garantie.module";
import {BhCommunityModule} from "../../../components/bh-community/bh-community.module";
import {BhSeenModule} from "../../../components/bh-seen/bh-seen.module";
import {
    BhWorkbooksSeriesListModule
} from "../../../components/bh-workbooks-series-list/bh-workbooks-series-list.module";
import {BhWorkbooksListModule} from "../../../components/bh-workbooks-list/bh-workbooks-list.module";
import {BhBundlesModule} from "../../../components/bh-bundles/bh-bundles.module";
import {BhTestimonialsModule} from "../../../components/bh-testimonials/bh-testimonials.module";



@NgModule({
  declarations: [BhPageStoreComponent],
  exports: [BhPageStoreComponent],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: "",
                component: BhPageStoreComponent
            }
        ]),
        BhFooterModule,
        BhCrumbsModule,
        BhHeaderModule,
        TranslocoPipe,
        AppPipesModule,
        NgOptimizedImage,
        BhAwardsModule,
        BhGradesModule,
        BhGarantieModule,
        BhCommunityModule,
        BhSeenModule,
        BhWorkbooksSeriesListModule,
        BhWorkbooksListModule,
        BhBundlesModule,
        BhTestimonialsModule,
    ]
})
export class BhPageStoreModule { }
